import { CookieSerializeOptions } from 'cookie'
import psl from 'psl'

const AUTH_COOKIE_MAX_AGE_MS = 60 * 60 * 24 * 400 * 1000 // 400 days

/**
 * Returns the cookie options used for all auth-related cookies (access
 * token, email, account id, account name, etc).
 *
 * The domain is derived from the public suffix list so that cookies
 * land on the registrable parent domain (e.g. `dashboard.focaldata.com`
 * → `focaldata.com`) and are shared across sibling subdomains. When
 * psl can't resolve a public suffix (e.g. on `localhost`), the cookie
 * stays scoped to the literal hostname.
 */
export function getAuthCookieOptions(): CookieSerializeOptions {
  const parsedHostname = psl.parse(window.location.hostname)
  return {
    domain:
      parsedHostname.error || !parsedHostname.domain
        ? window.location.hostname
        : parsedHostname.domain,
    expires: new Date(Date.now() + AUTH_COOKIE_MAX_AGE_MS)
  }
}
